<template>
    <inertia-head>
        <meta name="prerender-status-code" content="404" v-if="status === 404">
        <title>{{ pageTitle }}</title>
    </inertia-head>

    <div style="margin-top: 115px; padding: 25px;">
        <div class="modal fade" id="notFoundModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog coupon-modal" role="document">
                <div class="modal-content" style="justify-content: center;">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <span class="text-red" style="text-transform: capitalize; font-family: AvertaBlack; font-size: 38px; margin-bottom: 10px;">Ooops!</span>

                    <p class="text-red">
                        Vi kunde tyvärr inte hitta sidan du sökte.
                    </p>

                    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-danger">Hitta fler rabatter</button>
                </div>
            </div>
        </div>

        <div style="padding: 550px;"></div>
    </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
export default {
    props: {
        status: Number,
    },

    mounted () {
        if (this.status === 404) {
            $('#notFoundModal').on('hidden.bs.modal', () => {
                this.navigateToAllCampaigns();
            });
            $("#notFoundModal").modal("toggle");
        }
    },

    methods: {
        navigateToAllCampaigns () {
            $('.modal').modal('hide');
            router.visit(`/kampanjer`);
        }
    },

    computed: {
        pageTitle() {
            return {
                404: `Ooops! Vi kunde tyvärr inte hitta sidan du sökte`,
            }[this.status];
        },

        title() {
            return {
                503: '503: Service Unavailable',
                500: '500: Server Error',
                404: '404: Page Not Found',
                403: '403: Forbidden',
            }[this.status]
        },

        description() {
            return {
                503: 'Sorry, we are doing some maintenance. Please check back soon.',
                500: 'Whoops, something went wrong on our servers.',
                404: 'Sorry, the page you are looking for could not be found.',
                403: 'Sorry, you are forbidden from accessing this page.',
            }[this.status]
        },
    },
}
</script>
